import React, { useEffect,useState } from 'react';
import get from 'lodash/get';
import {
  DescriptionField,
  NameField,
  LogoutURLField,
  URLField,
  AbbreviationField,
  AppIdField,
  WorkflowIdIdField,
  EnterpriseIncludePermissionField,
  EnterpriseExcludePermissionField,
} from '../Elements';
import { TimeField } from '../Notification/Elements/TimeField';
import {
  AdminSideSheetFooterActions
} from './AdminActionButtons';
import { AdminCardPreview } from './AdminCardPreview';
import { CommonDropdown } from './AdminCommonSelector';
import { AdminWorkflowExplorer } from './AdminWorkflowExplorer';
import { ISideSheetData, IWorkflow } from '../AdminStore/slices/types/types';
import { SimpleLabel } from '../Elements/SimpleLabel';
import { useUnifyAdminStore } from '../AdminStore';
import {
  useApplicationCategory,
} from '../../../hooks/queries';
import { CdkuURLField } from '../Elements/CdkuURLField';
import {Checkbox} from 'cdk-radial';
import {SIDE_SHEET_TITLE_NAMES} from '../Constants'
import styled from "styled-components";
import {
  CustomScrollbarWrapper, Switch, DatePicker, IconSchedule, Toast, TOAST_POSITIONS, TOAST_VISIBILITY_DURATIONS, BUTTON_VARIANTS, IconCancelOutlined
, BUTTON_ICON_COLORS} from 'cdk-radial';
import { StyledWrapperDatePicker } from '../Notification/Blocks/OutageSideSheetDetails';
import moment, { Moment } from 'moment';
import { useTranslation } from 'react-i18next';

const statusOptions = [
  { label: 'Active', value: true },
  { label: 'Inactive', value: false },
];

interface IDetailSideSheet {
  sideSheetData: ISideSheetData | IWorkflow;
}

interface KeyValuePair {
   label: string,
   value: string
}

export interface iAppCategory {
  appCategory? : object
}


export const StyledCustomScrollbarWrapper = styled(CustomScrollbarWrapper)`
  height: calc(100% - 10px);
  overflow-x: hidden;
`;

export const StyledNewIndicatorField = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const AdminSideSheetDetails = ({
  sideSheetData,
}: IDetailSideSheet): JSX.Element => {
  const { t } = useTranslation();
    /**
     * Data hooks
     */
    const createNewApplication = useUnifyAdminStore(state => state.createNewApplication)
    const createNewWorkflow = useUnifyAdminStore(state => state.createNewWorkflow)
    const updateSideSheetData = useUnifyAdminStore(
      (state) => state.updateSideSheetData
    );  
    
    const { data } = useApplicationCategory();
    const [category,setCategory] = useState<KeyValuePair[]>();
    const [selectedCategory,setSelectedCategory] = useState<KeyValuePair>({label:'',value:''});
  /**
   * Local Component derived states
   */
  const shouldApplicationFieldsDisplay = get(sideSheetData, 'appId', false);
  const unrestricted = get(sideSheetData, 'isUnrestricted', false);
  const openInNewTab = get(sideSheetData, 'openInNewTab', false);
  const sideSheetTitleName = useUnifyAdminStore((state) => state.sideSheetTitleName)
  const permissions = useUnifyAdminStore(state => state.permissions);

  const [startDateError, setStartDateError] = useState(false);
  const [endDateError, setEndDateError] = useState(false);
  const [showNewIndicator, setShowNewIndicator] = useState(false);

  const [showToast, setShowToast] = useState(false);
  const [toastType, setToastType] = useState('');
  const [toastMsg, setToastMsg] = useState('');


  useEffect(()=>{
    if (data && data.appCategory){
      let array = Object.keys(data.appCategory);
      let categories:KeyValuePair[] = [];
      array.forEach(element => categories.push({label:element , value:element.toLowerCase()}));
      setCategory(categories);
      let provider = get(sideSheetData, 'appCategory', '');
      let selected:any = categories.find((cat:any) => cat.value === provider);
      setSelectedCategory(selected);
    }
    
    const startDate = get(sideSheetData, 'newStatusStartDate', null) as any;
    const endDate = get(sideSheetData, 'newStatusEndDate', null) as any;

    if(startDate && endDate && endDate > moment.utc()) {
      setShowNewIndicator(true);
    }
    //eslint-disable-next-line
  },[data, sideSheetData]);

  const selectedEnablementOption = {
    label: get(sideSheetData, 'isActive', false) ? 'Active' : 'Inactive',
    value: get(sideSheetData, 'isActive', false)
  };
  
  const onSelect = (options:any) =>{
    setSelectedCategory(options);
  }

  const onOpenInNewtabSwitch = (event: any) =>{
     updateSideSheetData({
            fieldName:'openInNewTab',
            value: event
          });
  }

  const onStatusStartDateChange = (event: Moment) => {
    const startTime = (get(sideSheetData, 'newStartTime', null) as any) || '00:00';
    if(startTime === '00:00') { updateSideSheetData({ fieldName:'newStartTime', value: startTime }); }
    updateSideSheetData({
        fieldName:'newStatusStartDate',
        value: event
      });

    setShowNewIndicator(false);
    setStartDateError(false);
    setEndDateError(false);
    const sd = event;
    const ed = get(sideSheetData, 'newStatusEndDate', null) as any;
     if(sd && ed && sd > ed) { // end is less then start
      updateSideSheetData({
            fieldName:'newStatusEndDate',
            value: null
          });
      setEndDateError(true);
    }
    else {
      if(sd && !ed) { // end date missing
        setEndDateError(true);
      }
      else if(!sd && ed) { // start date missing
        setStartDateError(true);
      }
      else if(sd && ed){ // both exists
        setShowNewIndicator(true);
      }
    }
  };

  const onStatusEndDateChange = (event: Moment) => {
    const endTime = (get(sideSheetData, 'newEndTime', null) as any) || '00:00';
    if(endTime === '00:00') { updateSideSheetData({ fieldName:'newEndTime', value: endTime }); }
    updateSideSheetData({
          fieldName:'newStatusEndDate',
          value: event
        });
    setShowNewIndicator(false);
    setStartDateError(false);
    setEndDateError(false);

    const sd = get(sideSheetData, 'newStatusStartDate', null) as any;
    const ed = event;
    if(sd && ed && ed < sd) { // end is less then start
      updateSideSheetData({
            fieldName:'newStatusStartDate',
            value: null
          });
      setStartDateError(true);
    }
    else {
      if(ed && !sd) { // start date missing
        setStartDateError(true);
      }
      else if(sd && !ed) { // end date missing
        setEndDateError(true);
      }
      else if(sd && ed){ // both exists
        setShowNewIndicator(true);
      }
    }
  };

  const onStartTimeChange = (event: string) => {
    updateSideSheetData({
        fieldName:'newStartTime',
        value: event || '00:00'
      });
  }

  const onEndTimeChange = (event: string) => {
    updateSideSheetData({
        fieldName:'newEndTime',
        value: event || '00:00'
      });
  }

  const showToastMessage = (msg:string, type:string) => {
    setToastMsg(msg);
    setToastType(type);
    setShowToast(true);
  }

  const resetToastState = () => {
    setToastMsg('');
    setToastType('');
    setShowToast(false);
  };

  const validateNewIndicator = () => {
    const sd = get(sideSheetData, 'newStatusStartDate', null) as any;
    const ed = get(sideSheetData, 'newStatusEndDate', null) as any;
      if(sd && !ed) {
        showToastMessage(t('appsAndWorkflows.toastEndDateRequired'), 'Error');
        return false;
      }
      if(ed && !sd) {
        showToastMessage(t('appsAndWorkflows.toastStartDateRequired'), 'Error');
        return false;
      }
    return true;
  }

  const handleValidation = () => {
    return validateNewIndicator();
  }
 
  return (
    <StyledCustomScrollbarWrapper>
          <div style={{padding:'10px'}}>
      {!shouldApplicationFieldsDisplay && <SimpleLabel />}
      {(createNewApplication || createNewWorkflow) &&  <AppIdField/>}
      { createNewWorkflow &&  <WorkflowIdIdField/>}
      <NameField />
      <DescriptionField />
      {(createNewApplication || sideSheetTitleName === SIDE_SHEET_TITLE_NAMES.APPLICATION_DETAILS)  && <Checkbox
          checked={!unrestricted}
          dataTestId="restricted-checkbox"
          label={t('appsAndWorkflows.restricted')}
          labelPosition="after"
          name="restricted"
          onChange={()=>updateSideSheetData({
            fieldName:'isUnrestricted',
            value:!unrestricted
          })}
          size="standard"
          isDisabled={permissions?.hasAppReadOnlyPermissions && !permissions?.hasAppSuperAdminPermissions && !permissions.hasAppUpdatePermissions}
      />}
      <CommonDropdown
        placeholder={t('appsAndWorkflows.enablementStatus') as string}
        options={statusOptions}
        selectedOption={selectedEnablementOption}
        label={t('appsAndWorkflows.enablementStatus') as string}
        name='isActive'
        />
      <EnterpriseIncludePermissionField/>
      <EnterpriseExcludePermissionField/>
      <URLField />
      <CdkuURLField />
      {(shouldApplicationFieldsDisplay || createNewApplication) && <LogoutURLField />}
      {(shouldApplicationFieldsDisplay || createNewApplication) && <AbbreviationField />}
      {(shouldApplicationFieldsDisplay || createNewApplication) && !createNewWorkflow && (
      <CommonDropdown
        options={category}
        selectedOption={selectedCategory}
        onSelect={onSelect}
        placeholder={t('appsAndWorkflows.appCategory') as string}
        label={t('appsAndWorkflows.appCategory') as string}
        name='appCategory'
       />
      )}
      <Switch style={{marginTop:"10px"}}
        dataTestId="switch-openin-new-tab"
        id="openinNewTab"
        label={t('appsAndWorkflows.enableOpenInNewTab')}
        labelPosition="after"
        name="openinNewTab"
        onChange={(event: any) => onOpenInNewtabSwitch(event.target.checked)}
        size="standard"
        checked={openInNewTab}
        isDisabled={permissions?.hasAppReadOnlyPermissions && !permissions?.hasAppSuperAdminPermissions && !permissions.hasAppUpdatePermissions}
      />
      <>
         <div style={{ fontWeight: 600 }}> {t('appsAndWorkflows.newStatusIndicator')}</div>
         <div
            style={{
              marginTop: '10px',
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <div style={{ width: '180px' }}>
              <StyledWrapperDatePicker dayPickerLeft="0px" maxWidth="180px">
                <DatePicker
                  dataTestId="start-date-picker"
                  date={get(sideSheetData, 'newStatusStartDate', null)}
                  dateFormat="MM/DD/YYYY"
                  dateInputProps={{
                    enableCustomValidation: true,
                    errorMessage: t('appsAndWorkflows.startDateError') as string,
                    hasError: startDateError,
                    isDisabled: false,
                    isReadOnly: false,
                    size: 'standard',
                    onError: () => {},
                  }}
                  allowDaysInPast={true}
                  id="start-date-picker"
                  label={t('appsAndWorkflows.startDate')}
                  maximumYear={2100}
                  minimumYear={1900}
                  name="start-date-picker"
                  numberOfMonths={1}
                  onDateChange={onStatusStartDateChange}
                  shortcutChipsPosition="none"
                />
              </StyledWrapperDatePicker>
            </div>

            <div style={{ width: '180px' }}>
              <StyledWrapperDatePicker dayPickerLeft="-132px" maxWidth="180px">
                <DatePicker
                  className="endDatePicker"
                  dataTestId="end-date-picker"
                  date={get(sideSheetData, 'newStatusEndDate', null)}
                  dateFormat="MM/DD/YYYY"
                  dateInputProps={{
                    enableCustomValidation: true,
                    errorMessage: t('appsAndWorkflows.endDateError') as string,
                    hasError: endDateError,
                    isDisabled: false,
                    isReadOnly: false,
                    size: 'standard',
                    onError: () => {},
                  }}
                  allowDaysInPast={true}
                  id="end-date-picker"
                  label={t('appsAndWorkflows.endDate')}
                  maximumYear={2100}
                  minimumYear={1900}
                  name="end-date-picker"
                  numberOfMonths={1}
                  onDateChange={onStatusEndDateChange}
                  shortcutChipsPosition="none"
                />
              </StyledWrapperDatePicker>
            </div>
          </div>
          <div
            style={{
              marginTop: '10px',
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <div style={{ width: '180px' }}>
              <TimeField
                icon={<IconSchedule />}
                handleChange={onStartTimeChange}
                value={get(sideSheetData, 'newStartTime') || '00:00'}
                name={'startTime'}
                label={t('appsAndWorkflows.startTime')}
                isDisabled={false}
                isRequired={false}
              />
            </div>
            <div style={{ width: '180px' }}>
              <TimeField
                handleChange={onEndTimeChange}
                value={get(sideSheetData, 'newEndTime') || '00:00'}
                name={'endTime'}
                label={t('appsAndWorkflows.endTime')}
                isDisabled={false}
                isRequired={false}
              />
            </div>
          </div>
      </>

      {showToast && (
        <Toast
          id="outage-notification-toast"
          datatestid="outage-notification-toast"
          position={TOAST_POSITIONS.FIXED}
          style={{
            marginTop: '70px',
            zIndex: 1003,
          }}
          variant={toastType === 'Error' ? 'negative' : 'positive'}
          visibilityDuration={TOAST_VISIBILITY_DURATIONS.SIX_SECONDS}
          onVisibilityDurationEnd={() => {
            resetToastState();
          }}
          actions={[
            {
              onClick: () => {
                resetToastState();
              },
              variant: BUTTON_VARIANTS.ICON,
              icon: <IconCancelOutlined />,
              iconColor: BUTTON_ICON_COLORS.GRAY,
              text: '',
            },
          ]}
          content={toastMsg}
        />
      )}

      {(shouldApplicationFieldsDisplay && !createNewApplication && !createNewWorkflow) && <AdminWorkflowExplorer />}
      <AdminCardPreview categories={data} selectedCategory={selectedCategory} showNewIndicator={showNewIndicator}/>
      <AdminSideSheetFooterActions handleValidation={handleValidation} />
          </div>
      </StyledCustomScrollbarWrapper>
  );
};
